const d = {
  standard: "standard",
  outlined: "outlined",
  filled: "filled"
};
export {
  d as INPUT_VARIANT
};
//# sourceMappingURL=inputVariant.es.js.map
